import styled from 'styled-components';
import { tokens, palette } from '@plataforma/components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 864px;
  height: 184px;
  padding: ${tokens.spacing.l};
  background: #f1f5f7;

  border-radius: 4px;
`;

export const Image = styled.img`
  .carousel .slide & {
    width: 227px;
    height: 162px;
  }

  margin-right: ${tokens.spacing.xl};
`;

export const Content = styled.div``;

export const Title = styled.h2`
  ${tokens.font['xl-emphasys']};
  color: ${palette['color-brand-primary']};
`;

export const Text = styled.p`
  ${tokens.font.base};
  color: ${palette['color-dark']};
  margin: ${tokens.spacing.s} 0 ${tokens.spacing.m} 0;

  & span {
    ${tokens.font['base-emphasys']};
  }
`;

export const LinkButton = styled.button`
  ${tokens.font['xs-emphasys']};
  color: ${palette['color-brand-primary']};

  border: none;
  outline: none;
  background-color: transparent;
  display: inline-flex;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
